export default __webpack_public_path__ + "static/media/chiranjeevi.d1854c52.jpg";